import type { components } from "../api/schema";

type TranscriptStatus = components["schemas"]["TranscriptStatus"];

export function transcriptStatusTone(
  status: TranscriptStatus,
): "danger" | "neutral" | "success" {
  if (status === "ready") {
    return "success";
  }
  if (status === "failed") {
    return "danger";
  }
  return "neutral";
}
